import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import isEmpty from 'lodash/isEmpty';
import cn from 'classnames';
import { getStringDate } from 'utils/getStringDate';
import Heading from '../Heading';
import ReportLoader from '../ReportLoader';

import { Table, TR } from '../../FullVinReportStyles';
import handcuffs from '../img/handcuffs.svg';

interface IRestrictionsList {
  start_date?: number;
  type?: string;
  organization?: string;
  region?: string;
}

interface IMappedRestrictions {
  [key: string]: { title: string; description?: string | number | null };
}

const Restrictions: FC = observer(() => {
  const {
    checksStore: {
      restrictions: { data, progress_ok },
    },
  } = useStores();

  const mappedRestrictions = (item: IRestrictionsList): IMappedRestrictions => {
    return {
      start_date: {
        title: 'Дата ограничения',
        description: getStringDate(item.start_date),
      },
      type: {
        title: 'Вид ограничения',
        description: item.type,
      },
      organization: {
        title: 'Организация',
        description: item.organization,
      },
      region: {
        title: 'Регион',
        description: item.region,
      },
    };
  };

  const renderHeadingDescription = () => {
    if (!isEmpty(data)) return 'Обнаружены ограничения';

    if (isEmpty(data) && !progress_ok) {
      return 'Сведения об ограничениях, арестах и залогах';
    }

    return 'Ограничений не обнаружено';
  };

  const renderRestrictions = () => {
    if (isEmpty(data) && progress_ok) return null;

    if (!isEmpty(data)) {
      return (
        <Table>
          <tbody>
            {data.map((restriction: IMappedRestrictions) => {
              return Object.keys(mappedRestrictions(restriction)).map((item, index) => {
                const { title, description } = mappedRestrictions(restriction)[item];
                const isFirst = index === 0;

                return (
                  <TR key={index} className={cn(!description && 'fake-hide')}>
                    <td className={cn(isFirst && 'setPadding', 'gray', !description && 'hidden')}>
                      {title}
                    </td>
                    <td>{description}</td>
                  </TR>
                );
              });
            })}
          </tbody>
        </Table>
      );
    }

    return <ReportLoader />;
  };

  return (
    <section className="section-box">
      <Heading
        icon={<img src={handcuffs} alt="icon-handcuffs" />}
        descr={renderHeadingDescription()}
        beCarefulState={!isEmpty(data)}
        isBorder={isEmpty(data) && progress_ok}
      />
      {renderRestrictions()}
    </section>
  );
});

export default Restrictions;
